import { useForm } from "react-hook-form";
import { getTemplate } from "../../api/salary";
import Axios from "../../utils/Axios";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  toastShowState,
  toastBgState,
  toastMessageState,
  toastAutoHideState,
  isBulkSalaryUpdatedState,
} from "../../utils/atoms/atoms";
import { useSetRecoilState, useRecoilValue } from "recoil";

const BulkUpdateModal = () => {
  const queryClient = useQueryClient();
  const setToastShow = useSetRecoilState(toastShowState);
  const setToastBg = useSetRecoilState(toastBgState);
  const setToastMessage = useSetRecoilState(toastMessageState);
  const setAutoHide = useSetRecoilState(toastAutoHideState);
  const setIsBulkSalaryUpdated = useSetRecoilState(isBulkSalaryUpdatedState);

  const updateSuccessToast = () => {
    setToastShow(true);
    setAutoHide(true);
    setToastBg("success");
    setToastMessage("Salary components have been updated");
  };

  const [fileInput, setFileInput] = useState("");
  // get the excel data
  const getData = () => {
    getTemplate();
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleFileChange = (e) => {
    setFileInput(e.target.value);
  };

  return (
    <div className="d-flex justify-content-around">
      <div className="btn-group flex-column" role="group" aria-label="Template">
        <div className="my-3 d-flex justify-content-evenly align-items-center">
          <label htmlFor="bulk-update-download" className="me-2">
            Download sheet for Bulk Update{" "}
          </label>
          <button
            id="bulk-update-download"
            type="button"
            className="styled-btn--std me-2 rounded"
            onClick={getData}
          >
            Download <i className="bi bi-download"></i>
          </button>
        </div>

        <form
          action=""
          onSubmit={handleSubmit((data, event) => {
            event?.preventDefault();
            const formData = new FormData();
            formData.append("excel_file", data.excel_file[0]);
            Axios.post("/employee/update/sendtemplate", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              responseType: "blob",
            }).then(() => {
              if (data.excel_file[0]) {
                setFileInput("");
                setIsBulkSalaryUpdated(true);
              }
            });
          })}
        >
          <div className="my-3">
            <label htmlFor="file-input" className="styled-btn--std me-2">
              <input
                id="file-input"
                type="file"
                {...register("excel_file")}
                onChange={(e) => {
                  handleFileChange(e);
                }}
                value={fileInput}
                accept=".xlsx"
              />
            </label>
          </div>

          <div className="my-4 d-flex justify-content-end">
            <button
              type="submit"
              className="styled-btn--std px-3 w-100"
              data-bs-dismiss="modal"
              placeholder="update"
              onClick={updateSuccessToast}
            >
              Submit
            </button>
            <div className="text-danger">
              {errors?.excel_file?.message?.toString()}
            </div>
          </div>
        </form>
      </div>
      <div className="w-50">
        <h3 className="text-center">Guidelines</h3>
        <ul>
          <li>
            All the employee details can be added in bulk using this sheet
          </li>
          <li>Employee Name and Id cannot be edited</li>
          <li>All fields should have only numbers except Employee notes</li>
          <li>Loan cut field should always be smaller than loan field</li>
          <li>All fields should have only numbers except Employee notes </li>
        </ul>
      </div>
    </div>
  );
};

export default BulkUpdateModal;
